"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegerArbitrary = void 0;

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var Stream_1 = require("../../stream/Stream");

var BiasNumericRange_1 = require("./helpers/BiasNumericRange");

var ShrinkInteger_1 = require("./helpers/ShrinkInteger");

var IntegerArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(IntegerArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(IntegerArbitrary);

  function IntegerArbitrary(min, max) {
    var _this;

    _classCallCheck(this, IntegerArbitrary);

    _this = _super.call(this);
    _this.min = min;
    _this.max = max;
    return _this;
  }

  _createClass(IntegerArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      var range = this.computeGenerateRange(mrng, biasFactor);
      return new NextValue_1.NextValue(mrng.nextInt(range.min, range.max), undefined);
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return typeof value === 'number' && Number.isInteger(value) && !Object.is(value, -0) && this.min <= value && value <= this.max;
    }
  }, {
    key: "shrink",
    value: function shrink(current, context) {
      if (!IntegerArbitrary.isValidContext(current, context)) {
        var target = this.defaultTarget();
        return (0, ShrinkInteger_1.shrinkInteger)(current, target, true);
      }

      if (this.isLastChanceTry(current, context)) {
        return Stream_1.Stream.of(new NextValue_1.NextValue(context, undefined));
      }

      return (0, ShrinkInteger_1.shrinkInteger)(current, context, false);
    }
  }, {
    key: "defaultTarget",
    value: function defaultTarget() {
      if (this.min <= 0 && this.max >= 0) {
        return 0;
      }

      return this.min < 0 ? this.max : this.min;
    }
  }, {
    key: "computeGenerateRange",
    value: function computeGenerateRange(mrng, biasFactor) {
      if (biasFactor === undefined || mrng.nextInt(1, biasFactor) !== 1) {
        return {
          min: this.min,
          max: this.max
        };
      }

      var ranges = (0, BiasNumericRange_1.biasNumericRange)(this.min, this.max, BiasNumericRange_1.integerLogLike);

      if (ranges.length === 1) {
        return ranges[0];
      }

      var id = mrng.nextInt(-2 * (ranges.length - 1), ranges.length - 2);
      return id < 0 ? ranges[0] : ranges[id + 1];
    }
  }, {
    key: "isLastChanceTry",
    value: function isLastChanceTry(current, context) {
      if (current > 0) return current === context + 1 && current > this.min;
      if (current < 0) return current === context - 1 && current < this.max;
      return false;
    }
  }], [{
    key: "isValidContext",
    value: function isValidContext(current, context) {
      if (context === undefined) {
        return false;
      }

      if (typeof context !== 'number') {
        throw new Error("Invalid context type passed to IntegerArbitrary (#1)");
      }

      if (context !== 0 && Math.sign(current) !== Math.sign(context)) {
        throw new Error("Invalid context value passed to IntegerArbitrary (#2)");
      }

      return true;
    }
  }]);

  return IntegerArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.IntegerArbitrary = IntegerArbitrary;